import { render, staticRenderFns } from "./PasoExito.vue?vue&type=template&id=4a23e7dc"
import script from "./PasoExito.vue?vue&type=script&setup=true&lang=js"
export * from "./PasoExito.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports